import { Api } from '@axiom/ui';
import type { Language } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class LanguagesApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiAltUrl,
    });
  }

  readLanguages() {
    return super.read<{ data: Language[] }>({
      endpoint: '/languages',
      method: 'GET',
    });
  }
}

export const LanguagesApi = new LanguagesApiClass();
